module.exports = __webpack_public_path__ + "media/media/cases/case-1-7793d44d5463ef7e0832d51e31964d6b.jpg";